module.exports = __webpack_public_path__ + "img/badge-1.d476159d.svg";